import script from "./ComplainPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplainPrint.vue?vue&type=script&setup=true&lang=js"

import "./ComplainPrint.vue?vue&type=style&index=0&id=6449921c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6449921c"]])

export default __exports__